module.exports = __webpack_public_path__ + "img/fbk_system.42c85c56.jpg";